import { render, staticRenderFns } from "./PridelovalecKratko.vue?vue&type=template&id=17c40ff8&"
import script from "./PridelovalecKratko.vue?vue&type=script&lang=js&"
export * from "./PridelovalecKratko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports